import { atom } from 'jotai'
import { getStoredAccessToken, getStoredRefreshToken } from '@services/token/tokenStorage'

// Custom atomy które obsługują oba formaty tokenów
// Używamy zwykłych atomów bo zarządzamy localStorage ręcznie w hooks
export const accessTokenAtom = atom<string | null>(getStoredAccessToken())
export const refreshTokenAtom = atom<string | null>(getStoredRefreshToken())
// Funkcja inicjalizująca użytkownika
const getInitialUser = (): string | null => {
  // Sprawdź Microsoft OAuth user_data
  const msUserData = localStorage.getItem('user_data')
  if (msUserData) {
    try {
      const userData = JSON.parse(msUserData)
      return userData?.email || userData?.mail || null
    } catch {
      // Kontynuuj
    }
  }

  // Sprawdź klasyczny user
  const regularUser = localStorage.getItem('user')
  if (regularUser && regularUser !== 'null') {
    try {
      const parsed = JSON.parse(regularUser)
      return typeof parsed === 'string' ? parsed : regularUser
    } catch {
      return regularUser
    }
  }
  return null
}

export const userAtom = atom<string | null>(getInitialUser())

// Interface for decoded JWT token
export interface DecodedToken {
  token_type: string
  exp: number
  iat: number
  jti: string
  user_id: number
  roles?: string[]
}

// Atom for storing user roles
export const userRolesAtom = atom<string[]>([])
